// Livros Ecos (EFAI/EFAF LAED1) que continuam com o rótulo "Ecos" em vez de "Ecos Experience"
export const ECOS_ONLY_SAP_CODES = [
  232829, 232830, 232831, 232832, 232833, 232834, 232835, 232836,
  232837, 232838, 232839, 232840, 232841, 232843, 232844, 232845,
  232846, 232847, 232848, 232849, 232850, 232851, 232852, 232855,
  232856, 232857, 232859, 232860, 232861, 232863, 232865, 232866,
].map(String)

const isEcos = p => (p.name || '').toLowerCase().startsWith('ecos ')
const isEcosOnly = p => ECOS_ONLY_SAP_CODES.includes(String(p.product_sap_code))

// P-27: rótulo do pack (Ecos quando todos os itens começam com "Ecos ")
export const educaLabelOf = items => {
  if (!items.length || !items.every(isEcos)) return 'Educamos'
  return items.some(isEcosOnly) ? 'Ecos' : 'Ecos Experience'
}
